// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"1348a0df","375":"51f80c11","518":"68c3cd51","724":"56191884","729":"b71e91fd"}[chunkId] + ".chunk.js";
};